import overviewWhite from "assets/svg/overviewWhite.svg";
import projectsBlack from "assets/svg/projectsBlack.svg";
import offersBlack from "assets/svg/offersBlack.svg";
import settingBlack from "assets/svg/settingBlack.svg";
import overviewBlack from "assets/svg/overviewBlack.svg";
import projectsWhite from "assets/svg/projectsWhite.svg";
import offersWhite from "assets/svg/offersWhite.svg";
import settingWhite from "assets/svg/settingWhite.svg";
import user from "assets/svg/profileUser.svg";
import userWhite from "assets/svg/profileUserWhite.svg";
import listedProjects from "assets/svg/listedProjects.svg";
import trackedProjects from "assets/svg/trackedProjects.svg";
import monitoredProjects from "assets/svg/monitoredProjects.svg";
import listedProjectsWhite from "assets/svg/listedProjectsWhite.svg";
import trackedProjectsWhite from "assets/svg/trackedProjectsWhite.svg";
import monitoredProjectsWhite from "assets/svg/monitoredProjectsWhite.svg";

export const sideBarItems = [
  {
    to: "/dashboard",
    icon: <img src={overviewWhite} alt="Overview Icon" />,
    icon2: <img src={overviewBlack} alt="Overview Icon" />,
    title: "Overview",
  },
  {
    to: "/projects",
    icon: <img src={projectsWhite} alt="projects" />,
    icon2: <img src={projectsBlack} alt="projects" />,
    title: "Projects",
  },
  {
    to: "/offers",
    icon: <img src={offersWhite} alt="offer" />,
    icon2: <img src={offersBlack} alt="Offer" />,
    title: "Offers",
  },
  {
    to: "/profile",
    icon: <img src={settingWhite} alt="setting Icon" />,
    icon2: <img src={settingBlack} alt="setting Icon" />,
    title: "Settings",
  },
];

export const UserSideBarItems = [
  {
    to: "/property-developers",
    icon: <img src={userWhite} alt="Property-developers" />,
    icon2: <img src={user} alt="Property-developers" />,
    title: "Developers",
  },
  {
    to: "/property-owners",
    icon: <img src={userWhite} alt="property-owners" />,
    icon2: <img src={user} alt="property-owners" />,
    title: "Property Owners",
  },
];

export const ProjectsSideBarItems = [
  {
    to: "/admin/listed-projects",
    icon: <img src={listedProjectsWhite} alt="Listed Projects" />,
    icon2: <img src={listedProjects} alt="Listed Projects" />,
    title: "Listed Projects",
  },
  {
    to: "/admin/tracked-projects",
    icon: <img src={trackedProjectsWhite} alt="Tracked Projects" />,
    icon2: <img src={trackedProjects} alt="Tracked Projects " />,
    title: "Tracked Projects",
  },
  {
    to: "/admin/monitored-projects",
    icon: <img src={monitoredProjectsWhite} alt="Monitored Projects " />,
    icon2: <img src={monitoredProjects} alt="Monitored Projects" />,
    title: "Monitored Projects",
  },
];
